<template>
  <v-container
    fluid
    grid-list-md
  >
  <v-layout row wrap>
      <v-flex xs12>

        <v-toolbar flat>
          <h2>Учетные записи школьных админов</h2>
          <v-dialog
            v-model="newSchooladminDialog"
            scrollable persistent modal
            width="640"
            transition="dialog-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn icon class="mx-3" color="secondary" v-on="on" :disabled="!isadmin">
                <v-icon>
                  add
                </v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="subtitle-1">
                Новый админ
                <v-spacer></v-spacer>
                <v-btn icon small @click="dialogNewSchooladminClose()"><v-icon>close</v-icon></v-btn>
              </v-card-title>
              <v-card-text>
                <v-text-field
                  v-model="ischooladminid"
                  label="Логин"
                ></v-text-field>

                <v-text-field
                  v-model="ipassword"
                  label="Пароль"
                ></v-text-field>

                <v-autocomplete
                  flat
                  label="Школа"
                  :items="schools"
                  v-model="ischoolid"
                  item-text="name"
                  item-value="schoolid" clearable
                ></v-autocomplete>
              </v-card-text>
              <br /><br />
              <v-card-actions>
                <v-btn
                  color="primary"
                  :disabled="!ischooladminid || !ischoolid || !ipassword"
                  @click="addSchooladmin()"
                >
                  Добавить
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn text
                  @click="dialogNewSchooladminClose()"
                >Отмена</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-spacer></v-spacer>

          <v-text-field
          label="поиск по фильтру"
          v-model="search"
          append-icon="search"
          style="max-width: 400px"
          outlined clearable hide-details flat
          ></v-text-field>

        </v-toolbar>
      </v-flex>
      <v-flex>
        <v-data-table
          no-data="пусто"
          no-data-text="пусто"
          no-results-text="ничего не найдено"
          :headers="headers"
          :items="schooladmins"
          :items-per-page="-1"
          :search="search"
          item-key="schooladminid"
          sort-by="schooladminid"
          hide-default-footer
          dense
        >
        <template v-slot:item.password="{ item }">
          <span v-if="!item.visible">{{'***********'}}</span>
          <span v-else-if="item.visible">{{item.password}}</span>
        </template>
        <template v-slot:item.actions="{item}">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" x-small text @click="togglePasswordVisibility(item)" class="mx-1">
                <v-icon :class="`${item.visible ? 'visible' : 'not-visible'}`">
                  {{item.visible ? 'visibility' : 'visibility_off' }}
                </v-icon>
              </v-btn>
            </template>
            <span>Показать пароль</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" x-small text @click="copyPassword(item.password)" class="mx-1">
                <v-icon>content_copy</v-icon>
              </v-btn>
            </template>
            <span>Копировать пароль</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" x-small text @click="updatePassword(item)" class="mx-1">
                <v-icon class="edit-action">edit</v-icon>
              </v-btn>
            </template>
            <span>Обновить пароль</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" x-small text @click="deleteSchooladmin(item)" class="mx-1">
                <v-icon class="delete-action">delete</v-icon>
              </v-btn>
            </template>
            <span>Удалить администратора</span>
          </v-tooltip>
        </template>
        <template v-slot:item.cts="{ item }">
          {{ dateFormat(item.cts) }}
        </template>
        </v-data-table>
      </v-flex>
      <Confirmation></Confirmation>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
import Confirmation from '@/components/Confirmation'

export default {
  name: 'SchooladminAccounts',
  components: { Confirmation },
  data: () => ({
    schooladmins: [],
    schools: [],
    search: '',
    newSchooladminDialog: false,
    ischooladminid: null,
    ipassword: null,
    ischoolid: null,
    timer: null,
    editPasswordDialog: false,
  }),
  methods: {
    async fetch () {
      await this.fetchSchools()
      await this.fetchSchooladmins()
    },
    async fetchSchools () {
      try {
        const { schools } = await this.$store.dispatch('sioRequest', { topic: 'fetch-schools' })
        this.schools = schools
      } catch (e) {
        this.store.dispatch('snack', e)
      }
    },
    async fetchSchooladmins () {
      try {
        const { schooladmins } = await this.$store.dispatch('sioRequest', { topic: 'fetch-schooladmins' })
        this.schooladmins = schooladmins.map(sa => {
          sa.visible = false
          sa.school = this.schools.find(s => s.schoolid === sa.schoolid).name || 'unknown'
          return sa
        })
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async copyPassword (pass) {
      try {
        await navigator.clipboard.writeText(pass)
        this.$store.dispatch('snack', { msg: 'Пароль скопирован в буфер обмена' })
      } catch ($e) {
        this.$store.dispatch('snack', $e)
      }
    },
    togglePasswordVisibility (item) {
      item.visible = !item.visible
      if (item.visible) {
        this.hidePassword(item)
      } else {
        clearTimeout(this.timer)
      }
    },
    hidePassword (item) {
      this.timer = setTimeout(() => {
        item.visible = !item.visible
      }, 3000)
    },
    async updatePassword (schooladmin) {
      try {
        await this.$store.dispatch('confirm', `Вы уверены, что хотите обновить пароль для школы <${schooladmin.school}>?`)
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'schooladmin-update-password',
          pl: {
            schooladminid: schooladmin.schooladminid
          }
        })
        this.fetch()
        this.$store.dispatch('snack', meta.msg)
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async addSchooladmin () {
      try {
        const { schooladmin, meta } = await this.$store.dispatch('sioRequest', {
          topic: 'add-schooladmin',
          pl: {
            schooladminid: this.ischooladminid,
            password: this.ipassword,
            schoolid: this.ischoolid

          }
        })
        this.dialogNewSchooladminClose()
        this.fetch()
        this.$store.dispatch('snack', meta)
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async deleteSchooladmin (item) {
      try {
        await this.$store.dispatch('confirm', `Удалить администратора в школе <${item.school}>?`)
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'delete-schooladmin',
          pl: {
            schooladminid: item.schooladminid

          }
        })
        this.fetch()
        this.$store.dispatch('snack', meta)
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    dialogNewSchooladminClose () {
      this.newSchooladminDialog = false
      this.ipassword = null
      this.ischooladminid = null
      this.ischoolid = null
    },
    dateFormat (cts) {
      return moment(cts).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  computed: {
    profile () {
      return this.$store.state.profile
    },
    scopes () {
      return this.profile ? this.profile.scopes : []
    },
    isadmin () {
      return this.scopes.includes('admin')
    },
    headers () {
      if (this.isadmin) {
        return [
          { text: 'Логин', value: 'schooladminid', align: 'left', width: 140 },
          { text: 'Школа', value: 'school', align: 'left', width: 200 },
          { text: 'Пароль', value: 'password', align: 'left', width: 140 },
          { text: 'Дата добавления', value: 'cts', align: 'left', width: 140 },
          { text: 'Действия', value: 'actions', align: 'center', width: 16 },
        ]
      } else {
        return [
          { text: 'Логин', value: 'schooladminid', align: 'left', width: 140 },
          { text: 'Школа', value: 'school', align: 'left', width: 200 },
          { text: 'Дата добавления', value: 'cts', align: 'left', width: 140 },
          { text: 'Действия', value: 'actions', align: 'center', width: 16 },

        ]
      }
    }
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    },
  },
  mounted () {
    if (this.profile) this.fetch()
  }
}
</script>

<style lang="css">
.visible {
  color: #93fa6e !important;
}
.not-visible {
  color: #ffd47d !important;
}
.edit-action {
  color: #0cc754 !important;
}
.delete-action {
  color: #ff6363 !important;
}
</style>
